export const FlagEN = () => {
  return (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="british flag"
    >
      <mask
        id="mask0_545_1016"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="16"
        height="14"
      >
        <rect width="16" height="14" fill="#C4C4C4" />
      </mask>
      <g mask="url(#mask0_545_1016)">
        <path d="M0 -0.00012207V13.9999H16V-0.00012207H0Z" fill="#012169" />
        <path
          d="M-2.6958 0.983215L18.6955 13.0829L-2.6958 0.983215ZM18.6955 0.983215L-2.6958 13.0829L18.6955 0.983215Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.05024 7.03233L-1.10986 2.06472L-0.329924 -0.0997314L8.00009 5.67954L16.3301 -0.0997314L17.11 2.06472L9.94994 7.03233L17.11 11.9999L16.3301 14.1644L8.00009 8.38511L-0.329924 14.1644L-1.10986 11.9999L6.05024 7.03233Z"
          fill="white"
        />
        <path
          d="M-2.6958 0.983215L18.6955 13.0829L-2.6958 0.983215ZM18.6955 0.983215L-2.6958 13.0829L18.6955 0.983215Z"
          fill="black"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.69996 7.03194L-0.980103 1.70359L-0.460143 0.26062L7.99986 6.13008L16.4599 0.26062L16.9798 1.70359L9.29976 7.03194L16.9798 12.3603L16.4599 13.8033L7.99986 7.93379L-0.460143 13.8033L-0.980103 12.3603L6.69996 7.03194Z"
          fill="#C8102E"
        />
        <path d="M7.99983 0.983215V13.0829V0.983215ZM-2.6958 7.03305H18.6955H-2.6958Z" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.78244 8.83335V13.9998H6.21723V8.83335H0V5.21918H6.21723V-0.000183105H9.78244V5.21918H16V8.83335H9.78244Z"
          fill="white"
        />
        <path d="M7.99983 0.983215V13.0829V0.983215ZM-2.6958 7.03305H18.6955H-2.6958Z" fill="black" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.06937 8.11032L9.0693 14.0003H6.93017L6.93024 8.11032H-0.551758V5.94182H6.93024V0.000305176H9.06937V5.94182H16.3891V8.11032H9.06937Z"
          fill="#C8102E"
        />
      </g>
    </svg>
  );
};
